// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__26aNi","containerItemsCenter":"Skeleton_containerItemsCenter__1v31z"};